$shm_hitalama_opencode_tool_card $mol_view
	name \
	status \
	input \
	content \
	error \
	options /
	attr *
		^
		status <= status \
	sub <= rows /
		<= Head $mol_view
			sub /
				<= Title $mol_paragraph
					title <= title \
				<= Status $mol_paragraph
					title <= status_title \
				<= Copy $mol_button_copy
					title \Копировать tool
					text <= copy_text \
		<= Input $shm_hitalama_text
			text <= input \
		<= Options $mol_view
			sub <= options /
		<= Content $shm_hitalama_text
			text <= content \
		<= Error $shm_hitalama_text
			text <= error \
